module.exports = __webpack_public_path__ + "media/contact.00dd20c2.webm";